//import Validation from 'rc-form-validation';
import React, {Component,Fragment} from 'react';
import { FormValidation } from "calidation";
import { signup, checkUsernameAvailability, checkEmailAvailability } from '../../util/APIUtils';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
class Signup extends Component {

    constructor(props) {
        super(props);
        this.state = {
            username: {
                value: ''
            },email: {
                value: ''
            }
        }
      this.validateUsernameAvailability = this.validateUsernameAvailability.bind(this);
      this.validateEmailAvailability = this.validateEmailAvailability.bind(this);
      this.handleInputChange = this.handleInputChange.bind(this);
    }
     

     onSubmit = ({ fields, errors, isValid }) => {         
        if (isValid) {           
        	
        	var settings={
        			'zohoCreatorToken':fields.zohoCreatorToken,
        			'zcApplicationName':fields.zcApplicationName,
        			'zcOwnername':fields.zcOwnername,
        	}
        	fields['setting']=settings;
        	//console.log(fields);
        	//return false;
        	signup(fields)
            .then(response => {   
                toast.success('Successfully registered!',{autoClose: false,hideProgressBar: false,closeOnClick: true,pauseOnHover: true});
                this.props.onSuccessLogin();
            }).catch(error => {             
                toast.error('Something is wrong!',{autoClose: 10000,hideProgressBar: false,closeOnClick: true,pauseOnHover: true});
            });
        }
  };


handleInputChange(event) {
        const target = event.target;
        const inputName = target.name;        
        const inputValue = target.value;
        this.setState({
            [inputName] : {
                value: inputValue
            }
        });
};

validateEmailAvailability() {
        // First check for client side errors in email
        const emailValue = this.state.email.value;
         if(emailValue.length>0){
        checkEmailAvailability(emailValue)
        .then(response => {
            if(response.available) {
                this.setState({
                    email: {
                        value: emailValue,
                        validateStatus: 'success',
                        errorMsg: null
                    }
                });
            } else {
                this.setState({
                    email: {
                        value: emailValue,
                        validateStatus: 'error',
                        errorMsg: 'This Email is already registered'
                    }
                });
            }
        }).catch(error => {
            // Marking validateStatus as success, Form will be recchecked at server
            this.setState({
                email: {
                    value: emailValue,
                    validateStatus: 'success',
                    errorMsg: null
                }
            });
        });
         }

       
    }
 validateUsernameAvailability() {
            const usernameValue = this.state.username.value;
            if(usernameValue.length>0){
                 checkUsernameAvailability(usernameValue)
                .then(response => {
                    if(response.available) {
                        this.setState({
                            username: {
                                value: usernameValue,
                                validateStatus: 'success',
                                errorMsg: null
                            }
                        });
                    } else {
                        this.setState({
                            username: {
                                value: usernameValue,
                                validateStatus: 'error',
                                errorMsg: 'This username is already taken'
                            }
                        });
                    }
                }).catch(error => {
                    this.setState({
                        username: {
                            value: usernameValue,
                            validateStatus: 'success',
                            errorMsg: null
                        }
                    });
                });
             
            }
           
 };


      render() {

          const config = {
                email: {
                    isRequired: "Email field is required!",
                    isEmail: "Valid emails only, please!"
                },
                firstName: {
                    isRequired: "field is required!"
                },
                username: {
                    isRequired: "field is required!",
                    isMinLength: {
                         message: 'Field must be at least 5 characters',
                         length: 5,
                    }
                },
                lastName: {
                    isRequired: "field is required!"
                },
                password: {
                    isRequired: "field is required!",
                    isMinLength: {
                        message: 'Field must be at least 5 characters',
                        length: 5
                    }
                },
                confirmpassword: {
                    isRequired: "field is required!",
                    isEqual: ({ fields }) => ({
                            message: 'The two password must match',
                            value: fields.password,
                            validateIf: fields.password.length > 0, // this can be a boolean too!
                        }),
                },company: {
                    isRequired: "field is required!"
                },zohoCreatorToken: {
                    isRequired: "field is required!"
                },zcApplicationName: {
                    isRequired: "field is required!"
                },zcOwnername: {
                    isRequired: "field is required!"
                }
    };


    


         const divStyle = {
               //backgroundImage:'url(./static/assets/images/background/login-register.jpg)',
          };

          const errorStyle = {
                 color: "#fc4b6c"
          }
            const loginbox = {
                width:"800px"
          }


      return(
 <section id="wrapper">
 <ToastContainer />
        <div className="login-register" style={divStyle}>        
            <div className="login-box card" style={loginbox}>
            <div className="card-body">
              <h3 className="box-title m-b-20">Sign Up</h3>
       

               <FormValidation className="form-horizontal form-material   row" onSubmit={this.onSubmit} config={config}>
                   {({ fields, errors, submitted }) => (
                    <Fragment>
                     
                     <div className="form-group col-md-6">
                             <input className="form-control form-control-line"  
                             type="text" name="firstName" placeholder="First Name"/>
                             {submitted && errors.firstName &&
                               <small className="form-control-feedback"  style={errorStyle}>{errors.firstName}</small>
                             }
                     </div>

                      <div className="form-group col-md-6">
                            <input className="form-control form-control-line" 
                            onChange={(event) => this.handleInputChange(event)}
                             onBlur={this.validateUsernameAvailability}
                            type="text" name="username" placeholder="Username"/>
                             {submitted && errors.username &&
                               <small className="form-control-feedback"  style={errorStyle}>{errors.username}</small>
                             }
                              <small className="form-control-feedback"  style={errorStyle}>{this.state.username.errorMsg}</small>

                     </div>

                      <div className="form-group col-md-6">
                            <input className="form-control form-control-line"  type="text" name="lastName" placeholder="Last Name"/>
                             {submitted && errors.lastName &&
                               <small className="form-control-feedback"  style={errorStyle}>{errors.lastName}</small>
                             }
                      </div>


                      <div className="form-group col-md-6">
                            <input className="form-control form-control-line"  type="password" name="password" placeholder="Password"/>
                             {submitted && errors.password &&
                               <small className="form-control-feedback"  style={errorStyle}>{errors.password}</small>
                             }
                      </div>
                   
                      <div className="form-group col-md-6">
                            <input className="form-control form-control-line" 
                            onChange={(event) => this.handleInputChange(event)}
                             onBlur={this.validateEmailAvailability}
                              type="text" name="email" placeholder="Email"/>
                             {submitted && errors.email &&
                               <small className="form-control-feedback"  style={errorStyle}>{errors.email}</small>
                             }
                               <small className="form-control-feedback"  style={errorStyle}>{this.state.email.errorMsg}</small>

                      </div>

                      <div className="form-group col-md-6">
                            <input className="form-control form-control-line"  type="password" name="confirmpassword" placeholder="Confirm Password"/>
                             {submitted && errors.confirmpassword &&
                               <small className="form-control-feedback"  style={errorStyle}>{errors.confirmpassword}</small>
                             }
                      </div>
                   
                    <div className="form-group col-md-6">
                            <input className="form-control form-control-line"  type="text" name="company" placeholder="Company"/>
                             {submitted && errors.company &&
                               <small className="form-control-feedback"  style={errorStyle}>{errors.company}</small>
                             }
                      </div>
                  

                      <div className="form-group col-md-6">
                      <input className="form-control form-control-line"  type="text" name="zohoCreatorToken" placeholder="Zoho Creator Token"/>
                       {submitted && errors.zohoCreatorToken &&
                         <small className="form-control-feedback"  style={errorStyle}>{errors.zohoCreatorToken}</small>
                       }
                     </div>
                      
                      <div className="form-group col-md-6">
                      <input className="form-control form-control-line"  type="text" name="zcApplicationName" placeholder="Zoho Application Name"/>
                       {submitted && errors.zcApplicationName &&
                         <small className="form-control-feedback"  style={errorStyle}>{errors.zcApplicationName}</small>
                       }
                     </div>
                      
                      <div className="form-group col-md-6">
                      <input className="form-control form-control-line"  type="text" name="zcOwnername" placeholder="Zoho Ownername"/>
                       {submitted && errors.zcOwnername &&
                         <small className="form-control-feedback"  style={errorStyle}>{errors.zcOwnername}</small>
                       }
                    </div>
                      
                    
                    
                    
                    
                     <div className="form-group col-md-12">
                      <button id="signup" className="btn-rounded btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light" type="submit">Sign Up</button>
                    </div>
                    

                    </Fragment>
               )}
              </FormValidation>


              
                  

                    
                    <div className="form-group m-b-0">
                        <div className="col-sm-12 text-center">
                            <p>Already have an account? <a href="/" className="text-info m-l-5"><b>Sign In</b></a></p>
                        </div>
                    </div>
                
                
            </div>
          </div>
        </div>
        
    </section>

      );
    }
}
export default Signup;